export default "__VITE_ASSET__C_ewds8D__"